import type { IPromotionRepository } from '../repositories/IPromotionRepository.js';

export function createGetSchemeByIdUseCase({ promotionRepository }: { promotionRepository: IPromotionRepository }) {
  return async function getSchemeByIdUseCase(id: string) {
    return promotionRepository.getSchemeById(id);
  };
}
